<template>
  <div class="sidebar" :data-color="activeColor" :data-background-color="backgroundColor">
    <div class="logo">
      <a class="simple-text logo-mini" @click="minimizeSidebar" style="cursor: pointer">
        <div class="logo-img">
          <img :src="logo" />
        </div>
      </a>
      <a class="simple-text logo-normal" target="_blank" style="display:inline">
        <template >{{ title }}</template>
      </a>

      <a @click="userInfoPopup" class="simple-text logo-normal" style="cursor: pointer; display:inline">
        <md-icon>perm_identity</md-icon>
      </a>


      <div class="navbar-minimize">
        <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </md-button>
      </div>
    </div>
      <div style="position: absolute; bottom: 20px; left: 10px; right: 10px;">
        <md-button class="md-button md-default md-sm full-size-button md-theme-default" style="min-width: auto;z-index:99" onclick="location.href='/login'">
          로그아웃
        </md-button>
      </div>

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>

    <modal v-if="isShowUserInfo" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">사용자 정보/비밀번호 변경<span style="color: red; font-weight: bold;" v-if="changPwdYn == 'Y'"> [ 비밀번호 설정/변경 ] </span></h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="() => {this.isShowUserInfo = false}">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <tr>
              <th>사용자 ID</th>
              <td><input type="text" v-model="userData.userNo" readonly></td>
              <th>사용자명</th>
              <td><input type="text" v-model="userData.userNm" readonly></td>
              <th>부서</th>
              <td><input type="text" v-model="userData.partNm" readonly></td>
            </tr>
            <tr>
              <th>직위</th>
              <td><input type="text" v-model="userData.levelNm" readonly></td>
              <th>입사일</th>
              <td>
                <div class="inline-flex">
                  <div class="inline-flex">
                    <input type="text" v-model="userData.joinDate" readonly>
                  </div>
                </div>
              </td>
              <th>직원구분</th>
              <td>
                <input type="text" v-model="userData.userStatusNm" readonly>
              </td>
            </tr>
            <tr>
              <th>사용권한</th>
              <td>
                <input type="text" v-model="userData.userRightNm" readonly>
              </td>
              <th>전화번호</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="userData.tel" v-mask="'############'">
                </div>
              </td>
              <th>E-mail</th>
              <td><input type="text" v-model="userData.email"></td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="footer">
        <div class="inline-flex right">
            <input type="password" v-model="userPasswd" placeholder="변경할 비밀번호 입력"><span style="color: red; font-weight: bold;" v-if="changPwdYn == 'Y'">&nbsp; [ 비밀번호를 설정[변경]해 주세요 ] </span>
        </div>
        <md-button class="md-info md-sm" @click="changeUserInfo">정보변경</md-button>
        <md-button class="md-info md-sm" @click="changeUserPassword">비밀번호변경</md-button>
        <md-button class="md-default md-sm" @click="() => {this.isShowUserInfo = false; }">취소</md-button>
      </template>
    </modal>
    
  </div>
</template>
<script>

import {Modal} from "@/components";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";

export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "교우회관리시스템"
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية"
    },
    activeColor: {
      type: String,
      default: "kuaa",
      validator: value => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
          "kuaa"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    /* modified by psk 20200615
    backgroundImage: {
      type: String,
      default: "./img/sidebar-2.jpg"
    },
    */
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: "/img/kuaa_logo_wh.png"
    },
    usrIco: {
      type: String,
      default: "/img/aaa.png"
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.changPwdYn = session.get('pwdChgYn');
    if(this.changPwdYn == 'Y')  this.userInfoPopup();
  },

  components: {
    Modal
  },

  data(){
    return {
      isShowUserInfo: false,
      userPasswd: null,
      changPwdYn: 'N',
      userData: {
        editYn: "Y",
        userNo: "",
        userNm: "",
        partNm: "",
        levelNm: "",
        tel: "",
        innerNo: "",
        joinDate: "",
        email: "",
        retireDate: "",
        userStatus: "",
        userRight: "",
        agentGb: ""
      },
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
 logout () {
      window.location = '/login';
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    
    userInfoPopup() {
      kuaaApi.sendServer(
          URL_CONST.GET_USER_INFO, 
          null, 
          "post", 
          response => {
            this.userData = response.data.data.contents;
            this.isShowUserInfo = true;
      });
    },

    changeUserInfo() {
      kuaaApi.sendServer(
          URL_CONST.CHANGE_USER_INFO,
          this.userData,
          "post",
          response => {
            this.isShowUserInfo = false;
            if(response.data.success){
              kuaaFnc.showSwal("사용자 정보 변경", "변경 되었습니다.");
            }else{
              kuaaFnc.showSwal("사용자 정보 변경", response.data.result);
            }
          });
    },
    changeUserPassword() {

      let reg = /(?=.*\d{1,15})(?=.*[a-zA-Z~`!@#$%\^&*()-+=]{1,15}).{8,15}$/;
      if(!reg.test(this.userPasswd)){
        this.isShowUserInfo = false;
        let modalOptions = kuaaFnc.getSwalModaloptions({
          html: "비밀번호 오류입니다.<br>[하나 이상의 문자와 하나 이상의 숫자로 최소 8 ~ 15자]"
        });
        Swal.fire(modalOptions).then(() => this.isShowUserInfo = true);
        return false;
      }

      kuaaApi.sendServer(
          URL_CONST.CHANGE_USER_PASSWD,
          {userPasswd: this.userPasswd},
          "post",
          response => {
            this.isShowUserInfo = false;
            kuaaFnc.showSwal("비밀번호 변경", "변경 되었습니다.");
            this.userPasswd = "";
            if(session.get('pwdChgYn') == 'Y') {
              session.set('pwdChgYn', 'N');
              this.changPwdYn = 'N';
            }
            this.$router.push({ path: "/login" });
          });
    },
    
  },

  mounted() {
  },

  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
 
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
